module.exports = __webpack_public_path__ + "img/KamaranSubhan.111adcef.jpg";